import ForumIndex from './Index.vue';
import ForumTopic from './Topic.vue';

export const routes = [
  {
    path: 'comunidade',
    name: 'talkvia_forum',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: ForumIndex,
  },
  {
    path: 'comunidade/topicos/:topicId',
    name: 'talkvia_forum_topic',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: ForumTopic,
  },
];
